import { render } from "./AdrMainWorkflow.vue?vue&type=template&id=b4ceba9e&scoped=true"
import script from "./AdrMainWorkflow.vue?vue&type=script&lang=js"
export * from "./AdrMainWorkflow.vue?vue&type=script&lang=js"

import "./AdrMainWorkflow.vue?vue&type=style&index=0&id=b4ceba9e&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4ceba9e"]])

export default __exports__